import React from "react";

const OrdersExecuted = () => {
  const orders = [
    ["Hospitals", "Textile Mills", "Sugar Plants"],
    ["Paper Mills", "Foundries", "Engineering Industries"],
    ["Solar Plants", "Oil & Gas Industries", "Solar Industries"],
    ["Education Institutions", "Commercial Complexes", "Co-Generating Plants"]
  ];

  return (
    <section className="orders-section">
      <h2 className="orders-title">Where We Cater</h2>

      <div className="orders-grid">
        {orders.map((row, rowIndex) => (
          <div key={rowIndex} className="orders-column">
            {row.map((item, i) => (
              <div key={i} className="order-item">
                <span className="check">✓</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default OrdersExecuted;
